import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import TitleContentColumns from './TitleContentColumns'
import AssociatedNgssStandardsTable from './AssociatedNgssStandardsTable'
import AssignmentPopupContainer from '../containers/AssignmentPopupContainer/index';
import Accordion from './Accordion'
import NgssTagGroup from './NgssTagGroup'
import { formatKeysToCamelCase, formatStudentKeysToCamelCase } from '../util.js'
import '../assets/css/components/module-sequence.css'
import { OnboardingTeacherContext } from '../contexts/OnboardingTeacherContextProvider'
import { status, step_id, handleTaskComplete, convertTeacherStartTrack } from '../components/OnboardingHomepage/onboardingUtils'

class ModuleSequence extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAssignmentPopupVisible: false,
      questData: ''
    }
  }

  static contextType = OnboardingTeacherContext
  componentDidUpdate() {
    //if current user has not completed all of the onboarding steps && has not completed explore content step then...
    const updateOnboardingCred = {
      stepId: _.indexOf(step_id, 'hasVisitedStorylines')
    }
    const updateOnboardingTaskComplete = {
      onComplete: json => {
        const errors = json.data.completeOnboardingStep.errors
        if (!_.isEmpty(errors)) {
          errors.map(error => console.error(error))
        }
        else {
          const data = json.data.completeOnboardingStep.updatedContext
          const teacherTrackUpdate = convertTeacherStartTrack(data)
          this.context.setTeacherStartTrack(prev => ({
            ...prev,
            completedSteps: this.context.teacherStartTrack.completedSteps + 1,
            ...teacherTrackUpdate
          }))
          this.context.setIsAllComplete(data.allOnboardingStepsCompleted)
          this.context.setCurrentPath('teacher_selfStartPath')
        }
      },
      onFailure: error => { console.error(error) }
    }

    if (!this.context.isAllCompleted && this.context.teacherStartTrack.steps.exploreContent !== _.indexOf(status, 'completed')) {
      handleTaskComplete(updateOnboardingTaskComplete, updateOnboardingCred)
    }
  }

  getOrderedQuests = () => _.map(this.props.sequence.quest_order, quest_id => _.find(this.props.sequence.quests, quest => String(quest.id) === String(quest_id)))

  render() {
    const { studentGroupingsProps: { collection, isFetching, fetchError }, formattedPes, sequence, module } = this.props
    formatStudentKeysToCamelCase(collection)
    return (
      <div className='module-subpage module-sequence'>
        <h1 className='semi-bold'>{sequence.title}</h1>
        <br />
        <TitleContentColumns title='Driving Question'>
          <p className='driving-question-text'>{sequence.guiding_question}</p>
        </TitleContentColumns>
        <TitleContentColumns title='Storyline'>
          <p className='storyline-text'>{sequence.description}</p>
        </TitleContentColumns>
        <TitleContentColumns title='Teaching'>
          <p className='teaching-text'>
            {sequence.teaching_guide_link ? <a href={sequence.teaching_guide_link} target='_blank' className='btn btn-primary'>View Teaching Guide on Google Drive</a> : 'Teaching guide coming soon'}
          </p>
        </TitleContentColumns>
        {this.state.isAssignmentPopupVisible &&
          <AssignmentPopupContainer
            assignableContent={this.state.questData || formatKeysToCamelCase(sequence)}
            studentGroupings={collection}
            handleClose={() => this.setState({ isAssignmentPopupVisible: false, questData: '' })}
            questId={(this.state.questData || {}).id}
            sequenceId={(this.state.questData || {}).id ? '' : sequence.id}
            usingDeletingForm={false}
          />
        }

        <br /><br />
        <h2 className='semi-bold'>Storyline Quests</h2>
        <br />

        <div className='accordion-group'>
          {_.map(this.getOrderedQuests(), (quest, id) =>
            <Accordion key={id} title={quest.name} dotText={`${id + 1}`}>
              <p>{formatKeysToCamelCase(quest).educationalDescription}</p>
              <NgssTagGroup objectWithNgssTags={formatKeysToCamelCase(quest)} size='small' />
              <br />
              <button
                onClick={() => this.setState((state) => {
                  quest.questType = 'Sequence Quest'
                  return { questData: formatKeysToCamelCase(quest), isAssignmentPopupVisible: true }
                }
                )}
                className='assign btn btn-success'>Assign Single Quest</button>
            </Accordion>
          )}
        </div>

        <button onClick={() => this.setState({ isAssignmentPopupVisible: true })} className='btn btn-lg btn-success assign-sequence'>Assign Storyline</button>
        <AssociatedNgssStandardsTable pes={formattedPes} dcis={sequence.ngss_dcis} seps={sequence.ngss_seps} cccs={sequence.ngss_cccs} />
      </div>
    );
  }
}

ModuleSequence.propTypes = {
  module: PropTypes.object.isRequired,
  sequence: PropTypes.object.isRequired,
  formattedPes: PropTypes.object.isRequired
}

export default ModuleSequence
